<div class="radio-input">
  <mat-radio-group
    [formControl]="control"
    class="radio-input__group {{ orientation }}"
  >
    <mat-radio-button
      *ngFor="let option of options"
      [value]="option.value"
      class="radio-input__button"
    >
      <span class="radio-input__label">{{ option.label }}</span>
    </mat-radio-button>
  </mat-radio-group>
</div>
